var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{on:{"click":_vm.downloadPdf}},[_vm._v("下载合格证pdf")]),_c('el-button',{on:{"click":_vm.downloadPdf1}},[_vm._v("下载水洗唛pdf")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }